import { createSelector } from "@reduxjs/toolkit"
import type { AppState } from "../reducer"

export const getGlobalMessages = createSelector(
  (state: AppState) => state.messages,
  (messages) => messages.global
)
